import { takeLatest, call, all, put } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';
import {
  FETCH_OPERATORS,
  fetchOperatorList,
  DEACTIVATE_FROM_APP,
  deactivateFromApp,
  RATE_LESS_THAN_MKT_RATE,
  rateLessThanMktRate,
  FO_RESPONSE_CONSIGNMENT,
  fetchFOResponseConsignment,
  fetchFOResponseQuotation,
  FO_RESPONSE_QUOTATION,
  FO_RESPONSE_VEHICLE,
  fetchFOResponseVehicles,
  FETCH_FEEDBACK_CONFIG,
  fetchFeedbackConfig,
  FETCH_FEEDBACK_VALUES,
  fetchFeedbackValues,
  SUBMIT_FEEDBACK,
  submitFeedback,
  INITIATE_EXOTEL,
  FETCH_OPERATOR_INFO,
  fetchOperatorInfo,
  initiateExotelCall,
  SEND_TOKEN_LINK,
  sendTokenLink,
  SEND_NOTIF_LINK,
  sendNotifications,
  RETRY_TOKEN_LINK,
  retryTokenLink,
  CONTROL_BOOKING_AUTOMATION,
  controlBookingAutomation,
  FETCH_OPERATOR_TOKENS,
  fetchOperatorTokens,
} from './action';
import { EXPIRE_INDENT, expireIndent } from 'pages/Placement/store/actions';
import { REQUEST } from 'utils/actionGenerator';
import urlHelper from './api';
import { fetchEntity, fetchEntitySpawn } from 'store/saga';
import * as apis from 'utils/api';
import { take } from 'lodash';
import { showToaster } from 'components/Toaster/action';

function* fetchOperators(action) {
  console.log(action);
  const { id, search, source, payload, minTonnage, maxTonnage, subscribed, searchCode } = action.params;
  const request = urlHelper.vehicleStateRequest(
    id,
    search,
    source,
    payload,
    minTonnage,
    maxTonnage,
    subscribed,
    searchCode,
  );
  yield fetchEntitySpawn(request, fetchOperatorList, payload);
}

function* sendDeactivateFromApp(action) {
  const { demandId, activate } = action;
  const request = urlHelper.deactivateFromApp(demandId, { activate });
  yield fetchEntitySpawn(request, deactivateFromApp, { toaster: { successMsg: 'Successful', errorMsg: '' }, activate });
}

function* rateLessThanMarketRate(action) {
  const { demandId, lessThanMinimumMarketRate } = action;
  const request = urlHelper.markLessThanMktRate(demandId, { lessThanMinimumMarketRate });
  yield fetchEntitySpawn(request, rateLessThanMktRate, {
    toaster: { successMsg: 'Successful', errorMsg: '' },
    lessThanMinimumMarketRate,
  });
}

function* fetchFOResponseFormConsignment(action) {
  const { code, extId, page, size } = action;
  const request = urlHelper.fetchFOResponseConsignment(code, page, size);
  yield fetchEntitySpawn(request, fetchFOResponseConsignment, { code });
}

function* fetchFOResponseFormQuotation(action) {
  const { code, extId, page, size } = action;
  const request = urlHelper.fetchFOResponseQuotation(code, extId, page, size);
  yield fetchEntitySpawn(request, fetchFOResponseQuotation, { code });
}

function* fetchFOResponseFormVehicles(action) {
  const { code, demandId } = action;
  const request = urlHelper.fetchFOResponseVehicle(code, demandId);
  yield fetchEntitySpawn(request, fetchFOResponseVehicles, { code });
}

function* fetchFeedbackConfigDetails() {
  const request = urlHelper.fetchFeedbackConfig();
  yield fetchEntitySpawn(request, fetchFeedbackConfig);
}

function* fetchFeedbackValDetails(action) {
  const { code, demandId } = action;
  const request = urlHelper.fetchFeedbackValues(code, demandId);
  yield fetchEntitySpawn(request, fetchFeedbackValues);
}

function* fetchOperatorInfoSaga(action) {
  const { code, demandId, extId } = action;
  const request = urlHelper.fetchOperatorInfo(code, demandId, extId);
  yield fetchEntitySpawn(request, fetchOperatorInfo);
}

function* submitFeedbackForm(action) {
  const { type, ...rest } = action;
  try {
    const request = urlHelper.submitFeedback.bind(null, rest);
    const response = yield call(request);
    if (response.data.success) {
      yield put(submitFeedback.success(response.data));
      yield put(showToaster({ toasterMsg: response?.data.message, toasterType: 'success' }));
    } else {
      yield put(showToaster({ toasterMsg: response?.data.message, toasterType: 'error' }));
    }
  } catch (error) {
    Sentry.captureException(error);

    console.log(error);
    yield put(showToaster({ toasterMsg: error.response.data.message ?? '', toasterType: 'error' }));
  }
}

function* initiateExotel(action) {
  const { code } = action;
  const request = urlHelper.initiateExotel(code);
  yield fetchEntitySpawn(request, initiateExotelCall);
}

function* sendTokenAmountLink(action) {
  const { code, demandId } = action;
  const request = urlHelper.sendTokenAmountLink({ opCode: code, demandId: demandId });
  yield fetchEntitySpawn(request, sendTokenLink, {
    toaster: { successMsg: 'Token link sent successfully', errorMsg: request.errorMsg },
  });
}

function* sendNotification(action) {
  const { code, demandId } = action;
  const request = urlHelper.sendNotification({ opCode: code, demandId: demandId });
  yield fetchEntitySpawn(request, sendNotifications, {
    toaster: { successMsg: 'link sent successfully', errorMsg: request.errorMsg },
  });
}

function* retryTokenAmountLink(action) {
  const { code, demandId } = action;
  const request = urlHelper.retryTokenAmountLink({ opCode: code, demandId: demandId });
  yield fetchEntitySpawn(request, retryTokenLink);
}

function* fetchOperatorTokensSaga(action) {
  const { demandId } = action.params;
  const request = urlHelper.fetchOperatorTokens(demandId);
  yield fetchEntitySpawn(request, fetchOperatorTokens);
}

export function* expireIndentRequest(action) {
  const { demandId, data } = action.params;
  const request = apis.expireIndent(demandId, data);
  yield fetchEntitySpawn(request, expireIndent, { toaster: { successMsg: 'Request successful' } });
}
export function* controlPlacementBookingAutomation(action) {
  const { payload } = action;

  const request = apis.stopBookingAutomation(payload);
  yield fetchEntitySpawn(request, controlBookingAutomation, { toaster: { successMsg: 'Request successful' } });
  window.location.reload();
}
function* mySaga() {
  yield takeLatest(FETCH_OPERATORS[REQUEST], fetchOperators);
  yield takeLatest(DEACTIVATE_FROM_APP[REQUEST], sendDeactivateFromApp);
  yield takeLatest(RATE_LESS_THAN_MKT_RATE[REQUEST], rateLessThanMarketRate);
  yield takeLatest(FO_RESPONSE_CONSIGNMENT[REQUEST], fetchFOResponseFormConsignment);
  yield takeLatest(FO_RESPONSE_QUOTATION[REQUEST], fetchFOResponseFormQuotation);
  yield takeLatest(FO_RESPONSE_VEHICLE[REQUEST], fetchFOResponseFormVehicles);
  yield takeLatest(FETCH_FEEDBACK_CONFIG[REQUEST], fetchFeedbackConfigDetails);
  yield takeLatest(FETCH_FEEDBACK_VALUES[REQUEST], fetchFeedbackValDetails);
  yield takeLatest(SUBMIT_FEEDBACK[REQUEST], submitFeedbackForm);
  yield takeLatest(INITIATE_EXOTEL[REQUEST], initiateExotel);
  yield takeLatest(EXPIRE_INDENT[REQUEST], expireIndentRequest);
  yield takeLatest(FETCH_OPERATOR_INFO[REQUEST], fetchOperatorInfoSaga);
  yield takeLatest(SEND_TOKEN_LINK[REQUEST], sendTokenAmountLink);
  yield takeLatest(SEND_NOTIF_LINK[REQUEST], sendNotification);
  yield takeLatest(RETRY_TOKEN_LINK[REQUEST], retryTokenAmountLink);
  yield takeLatest(CONTROL_BOOKING_AUTOMATION[REQUEST], controlPlacementBookingAutomation);
  yield takeLatest(FETCH_OPERATOR_TOKENS[REQUEST], fetchOperatorTokensSaga);
}

export default mySaga;
